module.exports = __webpack_public_path__ + "img/Corner-Beta.23be402a.png";